import { Component, Inject, Input, OnInit } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { AgencyContactInfo } from 'src/app/modules/route-planner/interfaces/route-planning/agency-contact-info.interface';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import {
  AGENCY_WEBSITE_LINK_ARIA_LABEL,
  CLOSE,
  CONTACT_INFO,
  IN_NUMBER,
  OR_IN_WEBSITE,
  ORDER_SEAT,
  PHONE_NUMBER,
  PLEASE_CONTACT_WITH,
  WEBSITE,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { MultiLanguage } from 'src/app/modules/route-planner/interfaces/multi-langauge.interface';

@Component({
    selector: 'app-agency-contact-info-pop-up',
    templateUrl: './agency-contact-info-pop-up.component.html',
    styleUrls: ['./agency-contact-info-pop-up.component.scss'],
    standalone: false
})
export class AgencyContactInfoPopUpComponent extends PopUpComponent implements OnInit {

  direction: Direction
  closeText: string
  orderSeatText: string
  contactInfoText: string
  pleaseContactWithText: string
  inNumberText: string
  orInWebsiteText: string
  phoneNumberText: string
  websiteText: string
  /** Resolved agency name for the current UI language (avoid shadowing contactInfo.agencyName). */
  agencyDisplayName: string

  contactInfo: AgencyContactInfo

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    @Inject(POPUP_DATA)
    public readonly data: { agencyId: number, isForOrderSeat: boolean },
    private readonly languageService: LanguageService
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.routePlanningService.getAgencyContactInfo(this.data.agencyId).subscribe((result: ServiceResponse<AgencyContactInfo>) => {
      this.contactInfo = result.data
      const language = this.languageService.getSelectedLanguage()
      this.agencyDisplayName =
        this.contactInfo.agencyName[language.symbol as keyof MultiLanguage]
    })
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
     this.direction = language.direction
     this.closeText = CLOSE[language.language]
     this.orderSeatText = ORDER_SEAT[language.language]
     this.contactInfoText = CONTACT_INFO[language.language]
     this.pleaseContactWithText = PLEASE_CONTACT_WITH[language.language]
     this.inNumberText = IN_NUMBER[language.language]
     this.orInWebsiteText = OR_IN_WEBSITE[language.language]
     this.phoneNumberText = PHONE_NUMBER[language.language]
     this.websiteText = WEBSITE[language.language]
    })
  }

  /** Accessible name: what the link does + opens in new tab (visible text stays URL). */
  get agencyWebsiteLinkAriaLabel(): string {
    const selected = this.languageService.getSelectedLanguage();
    const sym = selected.symbol as keyof MultiLanguage;
    const agency = this.contactInfo?.agencyName;
    let raw = '';
    if (agency != null) {
      if (typeof agency === 'string') {
        raw = agency;
      } else {
        const m = agency as MultiLanguage;
        raw = m[sym] ?? m.he ?? '';
      }
    }
    const name = String(raw).trim();
    const tpl =
      AGENCY_WEBSITE_LINK_ARIA_LABEL[selected.language] ??
      AGENCY_WEBSITE_LINK_ARIA_LABEL['english'];
    return tpl.replace('{0}', name || '—');
  }
}
